module.exports = __webpack_public_path__ + "img/company-honor-TPD-20241028.2cd06d92.jpg";